var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chart"},[_c('chart-pie',{attrs:{"data-list":_vm.pieData,"extra-option":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }